/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IFinanceCalculatorData } from './finance-calculator.data';
import { IFinanceCalculatorProps } from './finance-calculator.props.autogenerated';
import * as Msdyn365 from "@msdyn365-commerce/core";

export interface IFinanceCalculatorViewProps extends IFinanceCalculatorProps<IFinanceCalculatorData> {
    title?: React.ReactNode;
    text?: React.ReactNode;
    moduleClass?: string;
}

/**
 *
 * FinanceCalculator component
 * @extends {React.PureComponent<IFinanceCalculatorProps<IFinanceCalculatorData>>}
 */
class FinanceCalculator extends React.PureComponent<IFinanceCalculatorProps<IFinanceCalculatorData>> {
    public render(): JSX.Element | null {
        const { heading, paragraph} = this.props.config;
        const financialCalculatorTitle = heading && (
            <Msdyn365.Text
                className='fc-heading'
                tag={heading.tag ?? 'h2'}
                text={heading.text ?? ''}
                /*editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }}*/
            />
        );
        const financialCalculatorText = paragraph && (
            <Msdyn365.RichTextComponent
                text={paragraph}
                className='fc-text'
                /*editProps={{ onEdit: this.handleParagraphChange, requestContext: this.props.context.request }}*/
            />
        );
        const financialCalculatorViewProps = {
            ...this.props,
            title: financialCalculatorTitle,
            text: financialCalculatorText,
            moduleClass: this.props.config.className || ""
        };
        return this.props.renderView(financialCalculatorViewProps) as React.ReactElement;
    }
}

export default FinanceCalculator;
